module.exports = __webpack_public_path__ + "img/line-transactional-sm.ec01fa30.svg";